export function getAddressComponentByType(place, types) {
    var _a;
    for (const type of types) {
        const foundComponent = (_a = place.address_components) === null || _a === void 0 ? void 0 : _a.find((component) => component.types.includes(type));
        if (foundComponent) {
            return foundComponent;
        }
    }
}
//# sourceMappingURL=getAddressComponentByType.js.map